import { useState, useEffect } from 'react';
import { updateByRecord, updateConsent, getRecord } from 'mod/track/GoogleConsent/utils';
import { useStoreState } from 'base/store';

export type IGoogleConsentPopupInstance = {
    active: boolean;
    // Policy 弹窗
    rootPopupVisible: boolean;
    closeRootPopup: () => void;
    // Customise 弹窗
    customisePopupVisible: boolean;
    openCustomisePopup: () => void;
    closeCustomisePopup: () => void;
    preferencesChecked: boolean;
    setPreferencesChecked: (checked: boolean) => void;
    advertisingChecked: boolean;
    setAdvertisingChecked: (checked: boolean) => void;
    onConfirmChoice: () => void;
    // Privacy Policy 弹窗
    helpPopupVisible: boolean;
    openHelpPopup: () => void;
    closeHelpPopup: () => void;
};

export function useGoogleConsentPopup(): IGoogleConsentPopupInstance {
    const [active, setActive] = useState<boolean>(false);
    const [rootPopupVisible, setRootPopupVisible] = useState<boolean>(false);
    const [customisePopupVisible, setCustomisePopupVisible] = useState<boolean>(false);
    const [helpPopupVisible, setHelpPopupVisible] = useState<boolean>(false);
    const [preferencesChecked, setPreferencesChecked] = useState<boolean>(true);
    const [advertisingChecked, setAdvertisingChecked] = useState<boolean>(true);
    const { ua: { isApp }, country } = useStoreState('rootStore');

    useEffect(() => {
        if (['DE', 'GB'].includes(country) && !isApp) {
            if (getRecord()) {
                updateByRecord();
            } else {
                setActive(true);
                setRootPopupVisible(true);
            }
        }
    }, [country]);

    return {
        active,
        // Policy 弹窗
        rootPopupVisible,
        closeRootPopup: () => setRootPopupVisible(false),
        // Customise 弹窗
        customisePopupVisible,
        openCustomisePopup: () => setCustomisePopupVisible(true),
        closeCustomisePopup: () => setCustomisePopupVisible(false),
        preferencesChecked,
        setPreferencesChecked,
        advertisingChecked,
        setAdvertisingChecked,
        onConfirmChoice: () => {
            updateConsent({
                preferences: preferencesChecked,
                advertising: advertisingChecked,
            });
            setCustomisePopupVisible(false);
            setRootPopupVisible(false);
        },
        // Privacy Policy 弹窗
        helpPopupVisible,
        openHelpPopup: () => setHelpPopupVisible(true),
        closeHelpPopup: () => setHelpPopupVisible(false),
    }
}